<template>
  <button @click="goBack" :class="['button__return', { '--top': top }]">
    <Icon id="arrow" />
  </button>
</template>

<script>
import { Icon } from '@/components/global'
import { UsesRoutesMixin } from '@/mixins'

export default {
  name: 'ReturnButton',
  mixins: [UsesRoutesMixin],
  components: { Icon },
  props: {
    top: {
      type: Boolean,
      default: false,
    },
    wardrobe: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goBack() {
      if (this.wardrobe) this.$store.dispatch('saveAvatar')
      if (this.$router.options.history.state.back) return this.$router.back()
      this.$router.push({ name: this.ROUTES.HOME })
    },
  },
}
</script>
